import { EventType } from 'types'

export const cellMinHeight = 16 // Минимальная высота между интервалами
export const gapWidth = 8 // Ширина отступа между днями
export const dayWidth = 34 // Ширина блока для одной даты
export const timeLabelsWidth = 48
export const margin = 0 // Отступ слева
export const intervals = 25 // Количество линий: 00:00, 02:00, ..., 22:00, 00:00
export const lineGapY = 9 // Отступ для линий по оси Y, чтобы выровнять их относительно временных меток
export const noPremiumShownDays = 3 // Количество отображаемых дней с данными без премиум-подписки
export const shadowOffset = 5 // Размер тени у прямоугольника
export const premiumRight = (dayWidth + gapWidth) * noPremiumShownDays + shadowOffset

export const dateFormat = 'yyyy-MM-dd'
export const timeFormat = 'HH:mm:ss'

export const eventsMap: Record<EventType, { title: string; color: string }> = {
  [EventType.BREAST_LEFT]: {
    title: 'ГВ Левая',
    color: '#F58A89',
  },
  [EventType.BREAST_RIGHT]: {
    title: 'ГВ Правая',
    color: '#6DBBAE',
  },
  [EventType.BOTTLE]: {
    title: 'Бутылочка',
    color: '#FFC978',
  },
  [EventType.SLEEP_DAY]: {
    title: 'Дневной сон',
    color: '#5E85A7',
  },
  [EventType.SLEEP_NIGHT]: {
    title: 'Ночной сон',
    color: '#375F82',
  },
  [EventType.POO]: {
    title: 'Ка-ка',
    color: '#957F72',
  },
  [EventType.PEE]: {
    title: 'Пи-пи',
    color: '#FECA04',
  },
}
